import { render } from "./returnVisit.vue?vue&type=template&id=1d508a6a&scoped=true"
import script from "./returnVisit.vue?vue&type=script&lang=js"
export * from "./returnVisit.vue?vue&type=script&lang=js"

import "./returnVisit.vue?vue&type=style&index=0&id=1d508a6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d508a6a"

export default script